module.exports = __webpack_public_path__ + "static/media/infoActiveUserInvite.8abddbbb.svg";